import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";
import { appManager, EventType } from "../../AppManager";
import botAvatar from "../../images/botAvatar.svg";
import VideoPlayer from "../Common/VideoPlayer";
import { imageData } from "../UserDetails/UserDetails";
import { selectUserDetails } from "../UserDetails/userDetailsSlice";
import chatList from "./chatList.json";
import { useStyles } from "./HelpStyle";
export interface IChatList {
  key: string;
  message: string;
  timeOut: number;
  summary?: IChatList[];
}

export interface IChatComponent {
  chatList: IChatList[][];
  displayNextSlide: () => void;
  overlayLoader?: number;
  consoleImg?: boolean;
  isRoom?: boolean;
  videoDisplayNextSlide?: () => void;
}

const ChatComponent = (props: IChatComponent) => {
  const classes = useStyles();
  const [chatIndex, setChatIndex] = React.useState(0);
  const [isLoader, setLoader] = React.useState(false);
  const [displayImg, setImg] = React.useState([false, false]);

  const [scriptChatIndex, setScriptChatIndex] = React.useState({
    index: -1,
    key: "",
    message: "",
    timeOut: 0,
    summary: [] as IChatList[],
  });

  const { fname, avatar } = useSelector(selectUserDetails);

  const playPing = () => {
    appManager.sendMessageToHost(EventType.ChatPing, "ChatPing");
  };

  React.useEffect(() => {
    const chatContent: IChatList[] = props?.chatList[chatIndex];

    if (chatContent && chatContent.length >= scriptChatIndex.index + 1) {
      const chatContent2: IChatList[] = [];
      chatContent.forEach((element, index) => {
        index <= scriptChatIndex.index && chatContent2.unshift(element);
      });
      let message = chatContent[scriptChatIndex.index + 1];
      if(scriptChatIndex.index !== -1 && scriptChatIndex.message !== '...'){
        playPing();
      }
      setTimeout(() => {
        message?.key === "right"
          ? setImg([true, displayImg[1]])
          : setImg([displayImg[0], true]);
        setScriptChatIndex({
          index: scriptChatIndex.index + 1,
          summary: chatContent2,
          ...message,
        });
      }, scriptChatIndex?.timeOut);
    } else if (chatList.length > chatIndex + 1) {
      setChatIndex(chatIndex + 1);
      setImg([false, false]);
      setScriptChatIndex({
        index: -1,
        key: "",
        message: "",
        timeOut: 0,
        summary: [] as IChatList[],
      });
    } else showOverlayLoader();
  }, [scriptChatIndex]);

  const showOverlayLoader = () => {
    if (isLoader) {
      setLoader(false);
      props.displayNextSlide();
    } else if (props?.overlayLoader === 1) {
      setLoader(true);
    } else props.displayNextSlide();
  };
  const chatConvo = (
    <>
      {scriptChatIndex &&
        scriptChatIndex?.summary.map((element, index) => {
          let prevIndex = scriptChatIndex?.summary[index - 1]?.key;
          let flag =
            (prevIndex && element.key !== prevIndex) ||
            (index === 0 && element.key !== scriptChatIndex.key);
          return element.key === "right" ? (
            <Grid
              item
              xs={12}
              className={classes.rightGrid}
              key={index}
              style={{ marginBottom: flag ? "0.5rem" : "0.2rem" }}
            >
              <img
                src={imageData[avatar]?.chatImage}
                alt="user Avatar"
                className={classes.avatar}
                style={{ visibility: flag ? "visible" : "hidden" }}
              />

              <div
                className={
                  element?.message.length > 3
                    ? classes.rightBubble
                    : classes.typingRightDiv
                }
              >
                <Typography sx={{ fontSize: "0.7rem", color: "white" }}>
                  {element?.message.replace("$fname", fname)}
                </Typography>
              </div>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              className={classes.leftGrid}
              key={index}
              style={{ marginBottom: flag ? "0.5rem" : "0.2rem" }}
            >
              <img
                src={botAvatar}
                alt="Avatar"
                className={classes.avatar}
                style={{ visibility: flag ? "visible" : "hidden" }}
              />

              <div
                className={
                  element?.message.length > 3
                    ? classes.leftBubble
                    : classes.typingLeftDiv
                }
              >
                <Typography sx={{ fontSize: "0.7rem" }}>
                  {element?.message.replace("$fname", fname)}
                </Typography>
              </div>
            </Grid>
          );
        })}
    </>
  );
  return (
    <div className={clsx(classes.positionComponent, classes.bg)}>
      {props?.consoleImg && (
        <VideoPlayer
          videoURL={"asset/video/ScanningProgressVideo.mp4#t=6,38"}
          displayNextSlide={props?.videoDisplayNextSlide ?? (() => {})}
          styles={{
            position: "absolute",
            left: "5%",
            top: "11%",
            marginTop: "3rem",
            height: "20%",
            width: "40%",
          }}
        />
      )}
      <Grid className={classes.contentDiv}>
        {scriptChatIndex && scriptChatIndex?.key === "right" && (
          <Grid item xs={12} className={classes.rightGrid}>
            <img
              src={imageData[avatar]?.chatImage}
              alt="user Avatar"
              className={classes.avatar}
            />
            <div
              className={
                scriptChatIndex?.message.length > 3
                  ? classes.rightBubble
                  : classes.typingRightDiv
              }
            >
              <Typography sx={{ fontSize: "0.7rem", color: "white" }}>
                {scriptChatIndex?.message.replace("$fname", fname)}
              </Typography>
            </div>
          </Grid>
        )}
        {scriptChatIndex && scriptChatIndex?.key === "left" && (
          <Grid item xs={12} className={classes.leftGrid}>
            <img src={botAvatar} alt="Avatar" className={classes.avatar} />
            <div
              className={
                scriptChatIndex?.message.length > 3
                  ? classes.leftBubble
                  : classes.typingLeftDiv
              }
            >
              <Typography sx={{ fontSize: "0.7rem" }}>
                {scriptChatIndex?.message.replace("$fname", fname)}
              </Typography>
            </div>
          </Grid>
        )}
        {chatConvo}
      </Grid>

      {props?.isRoom && (
        <div className={classes.overlayDiv}>
          <div className={classes.overlayDivTypo}>
            <Typography
              variant="body2"
              sx={{ fontWeight: "700", color: "#FFF" }}
            >
              Please go to ‘Imaging Control room’.
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatComponent;
